export const FETCH_POSTS = 'FETCH_POSTS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SET_LOCALE = 'SET_LOCALE';
export const CARGO_POST = 'CARGO_POST';
export const CONFIG_DATA_FETCHED = 'CONFIG_DATA_FETCHED';
export const USER_PROFILE_FETCHED = 'USER_PROFILE_FETCHED';
export const SHIFT_CLOSED = 'SHIFT_CLOSED';
export const CUSTOMER_DATA = 'CUSTOMER_DATA';
